<script>
export default {
  name: 'WorkOrderPlaceholderTab',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<template>
  <article class="wo-panel wo-placeholder-panel">
    <h2>{{ title }}</h2>
    <p>Content for this tab is not configured yet.</p>
  </article>
</template>
